import { Tag } from 'components/Toolkit/Tags/Tag';

function DeliveryAvailableTag() {
  return <Tag text="Delivery" textColor="GREY_DARK" bgColor="GREY_LIGHTER" />;
}

export { DeliveryAvailableTag };
